import React from "react";
import "./HomePage.css";
import { Link } from "react-router-dom";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function HomePage() {
  return (
    <div className="HomePage">
      <div className="hero">
        <h1 className="hero-text">
          Hi, I am <span>Alabi Timothy</span>
        </h1>
        <p className="h-sub-text">
          A highly motivated, adaptable and responsible individual seeking a
          position in any capacity in which the professional, technical and
          interpersonal skills developed through past experiences will be
          utilized. I have a methodical, customer-focused approach to work and a
          strong drive to see things through to completion.
        </p>
        <div className="icons">
          <Link
            className="icon-holder"
            to="https://www.linkedin.com/in/halabitimoty"
          >
            <FontAwesomeIcon icon={faLinkedin} className="icon fa" />
          </Link>
          <Link className="icon-holder" to="https://github.com/Halabitimoty">
            <FontAwesomeIcon icon={faGithub} className="icon gt" />
          </Link>
          <Link className="icon-holder" to="https://twitter.com/halabitimoty">
            <FontAwesomeIcon icon={faTwitter} className="icon yb" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
